import { pageLanguage, type Language } from '@bn-games/i18n-core';
import type { MahjongThemeName } from './themes.js';

export type { Language, MahjongThemeName };

/**
 * Mahjong settings. The base `@bn-games/settings-core` SettingsManager is
 * generic over `TSettings extends object`; the canonical `theme` + `language`
 * fields live here alongside the trainer-specific `coachEnabled` toggle.
 */
/**
 * Iteration-2's ruleset selector. Matches `game/ruleset/*.ts`'s `id`
 * literals exactly — this setting picks which `Ruleset` gets constructed
 * (wired in T17), it doesn't own the ruleset objects itself.
 */
export type Variant = 'simplified' | 'classical';

/** Matches match/MatchState.ts's STARTING_POINTS. */
export const DEFAULT_CLASSICAL_STARTING_POINTS = 2000;

export interface Settings {
  readonly language: Language;
  readonly theme: MahjongThemeName;
  readonly coachEnabled: boolean;
  readonly variant: Variant;
  readonly classicalStartingPoints: number;
  /**
   * Plays a short cue when the turn reaches my seat. Mahjong's only sound —
   * bots and remote seats act on their own clock, so "it's on you now" is the
   * one moment worth hearing.
   */
  readonly turnStartSound: boolean;
}

export const DEFAULT_SETTINGS: Settings = {
  // A /…/ru/ page opens in Russian unless the player already chose a language.
  language: pageLanguage(),
  theme: 'greenFelt',
  coachEnabled: true,
  variant: 'simplified',
  classicalStartingPoints: DEFAULT_CLASSICAL_STARTING_POINTS,
  turnStartSound: true,
};
